import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import Footer from './Footer';

interface AppShellProps {
  contained?: boolean;
}

export const AppShell: React.FC<AppShellProps> = ({ contained = false }) => (
  <div className={`min-h-screen flex flex-col ${contained ? 'bg-muted/30' : 'bg-background'}`}>
    <SiteHeader />
    <main className={`flex-1${contained ? ' container mx-auto px-4 py-6' : ''}`}>
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default AppShell;
